export enum EtatSpecification {
  ARCHIVED = "ARCHIVED",
  EN_COURS = "EN_COURS",
  EN_REDACTION = "EN_REDACTION",
  REDIGEE = "REDIGEE",
  VALIDEE = "VALIDEE",
  APPROUVEE = "APPROUVEE",
}

